import axios from 'axios';
import {apiService} from "../../services/api.service";
import {extractData, handleResponse} from "../../helpers/apiResponseHelper";
import {IDispensingOrderEditRequestForm, IDispensingOrderRequestForm, ISavingProgress} from "./models";

export const DispensingOrdersService = {
    getDispensingOrders: getDispensingOrders,
    getDispensingOrderFuels: getDispensingOrderFuels,
    getCarriers: getCarriers,
    getCars: getCars,
    getDrivers: getDrivers,
    postDispensingOrder: postDispensingOrder,
    getDispensingOrderCreationProgress: getDispensingOrderCreationProgress,
    putDispensingOrder: putDispensingOrder,
};

async function getDispensingOrders(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/dispensing-order/' + customerId)
        .then(handleResponse).then(extractData);
}

async function getDispensingOrderFuels(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/customer-product/dispensing-order-fuels/' + customerId)
        .then(handleResponse).then(extractData);
}

async function getCarriers() {
    return axios.get(apiService.getApiUrl() + '/carriers')
        .then(handleResponse).then(extractData);
}

async function getCars(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/cars/' + customerId + '?isRemoteId=true')
        .then(handleResponse).then(extractData);
}

async function getDrivers(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/drivers/' + customerId + '?isRemoteId=true')
        .then(handleResponse).then(extractData);
}

async function postDispensingOrder(customerId: number, formData: IDispensingOrderRequestForm) {
    return new Promise<string>((resolve, reject) => {
        axios.post(
            apiService.getApiUrl() + "/dispensing-order/" + customerId,
            JSON.stringify(formData),
            {
                headers: {
                    "content-type": "application/json"
                }
            }).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response && error.response.data && error.response.data.id) {
                reject(error.response.status + " : " + error.response.data.id)
            } else {
                reject(500)
            }
        });
    });
}

async function getDispensingOrderCreationProgress(customerId: number, uid: string, action: 'save' | 'edit') {
    return new Promise<ISavingProgress>((resolve, reject) => {
        axios.post(
            apiService.getApiUrl() + "/dispensing-order/" + action + "-state/" + customerId,
            {
                uid: uid
            },
            {
                headers: {
                    "content-type": "application/json"
                }
            }).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response) {
                reject(error.response.status)
            } else {
                reject(500)
            }
        });
    });
}

async function putDispensingOrder(customerId: number, formData: IDispensingOrderEditRequestForm) {
    return new Promise<string>((resolve, reject) => {
        axios.put(
            apiService.getApiUrl() + "/dispensing-order/" + customerId,
            JSON.stringify(formData),
            {
                headers: {
                    "content-type": "application/json"
                }
            }).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response && error.response.data && error.response.data.id) {
                reject(error.response.status + " : " + error.response.data.id)
            } else if (error.response && error.response.rows) {
                reject(error.response.status + " : " + error.response.rows.map((row: any) => row.field + ' '+ row.message));
            } else {
                reject(500)
            }
        });
    });
}
